import { useStaticQuery, graphql } from 'gatsby';


export const Architecture = () => {
	const { wpgraphql } = useStaticQuery(
		graphql`
			query architecturePosts {
				wpgraphql {
					posts(first: 12, where: { categoryName: "architecture" }) {
						nodes {
							title
							link
							colourFeatureImage
							featuredImage {
								sourceUrl
								srcSet
								mediaDetails {
									width
									height
								}
							}
							avVideoTeaser {
								avVideoTeaser {
								mediaItemUrl
								}
							}    								
						}
					}
				}
			}
		`
	);

	return wpgraphql.posts.nodes;
};
